import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthMethods } from '@user/const';
import { LoginService } from '@user/data-access';
import { Observable } from 'rxjs';
import { LoginFormComponentService } from './login-form-component.service';

@Component({
  selector: 'sd-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LoginFormComponentService],
  standalone: false,
})
export class LoginFormComponent implements OnInit, OnDestroy {
  authMethods = AuthMethods;

  currentAuthMethod$: Observable<AuthMethods>;

  constructor(
    private loginService: LoginService,
    private loginFormComponentService: LoginFormComponentService,
  ) {}

  ngOnInit(): void {
    this.currentAuthMethod$ = this.loginFormComponentService.getCurrentAuthMethod();
  }

  ngOnDestroy(): void {
    this.loginService.resetConfirmPhoneState();
  }
}
